const english  = {
navbarTitle1:"Home",
navbarTitle2:"Service",
navbarTitle3:"Price",
navbarTitle4:"Our Clients",
navbarTitle5:"About Us",
navbarTitle6:"Contact",
// hero page
homeHeaderTitle1:"WE HAVE SOLUTIONS TO YOUR BUSSINESS PROBLEMS",
homeHeaderTitle2: "We leverage assests in order to make the best solutions.", 
homeHeaderSubtitle2: "Your future starts here.",
homeHeaderFormTitle:"Contact with Us",
homeHeaderInputTitle:"Name",
homeHeaderInputTitle1:"Phone Number",
homeHeaderInputTitle2:"Email Address",
homeHeaderInputTitle3:"Service",
homeHeaderInputTitle4: "Сompany",
homeHeaderInputTitle5: "Budget",
homeButton:"Get Started",
homeFormAlertTitle1:"Name required!",
homeFormAlertTitle2:"Phone number required",
homeFormAlertTitle3:"The name must contain at least 4 characters!",
homeFormAlertTitle4:"The phone number must contain at least 12 characters",
homeFormAlertTitle12: "Company name required",
  homeFormAlertTitle13:"The company name must contain at least 4 characters!",
// our service page
ourServiceTitle:"Marketing Solutions",
ourServiceSubtitle:"Unlock your brand's potential with our comprehensive marketing solutions. From precise Google Ads and targeted Facebook campaigns to effective SEO strategies, we help you connect, engage, and grow your audience.",
ourServiceCardText1:"Drive targeted traffic to your website and boost conversions with Google Ads. Our expert team creates and manages impactful campaigns, ensuring your ads reach the right audience at the right time.",
ourServiceCardText2:"Engage your audience with tailored Facebook Ads. Our team designs eye-catching campaigns that connect with your target market, driving more traffic, leads, and conversions for your business.",
ourServiceCardText3:"New customers mean more than just clicks. Unlock your business potential with Yandex Direct. Create, optimize, and track ad campaigns with ease. Expand your audience today!",
ourServiceCardText4:"Boost your online visibility and organic traffic with expert SEO strategies. We optimize your website to rank higher on search engines, helping you attract more qualified leads and grow your business.",
// price service page
priceTitle:"Explore Our Pricing",
priceSubtitle:"Discover flexible pricing plans tailored to your business needs. From budget-friendly packages to comprehensive solutions, we offer transparent pricing with no hidden fees. Find the perfect plan to maximize your ROI and drive your business forward.",
priceCardtitle1:"Default",
priceCardtitle2:"Premium",
priceCardtitle3:"Enterprise",
priceCardtext1:"Free account audit",
priceCardtext2:"from $500 monthly advertising spend",
priceCardtext22:"from $1000 monthly advertising spend",
priceCardtext3:"Free Google Ads account setup (if you don't have one)",
priceCardtext4:"Comprehensive weekly report",
priceCardtext5:"Setup of 1 campaign",
priceCardtext6:"Search: 50 keywords, 1 ad group, 1 ad",
priceCardtext7:"Display: 1 banner design",
priceCardtext8:"Campaign optimization",
priceCardtext9:"Free keyword research",
priceCardtext10:"Your campaigns will be managed by experts",
// second card details
priceCard2text1:"Free account audit",
priceCard2text2:"Free Google Ads account setup (if you don't have one)",
priceCard2text3:"Detailed weekly report",
priceCard2text4:"Detailed monthly report",
priceCard2text5:"Setup of 5 campaigns",
priceCard2text6:"Search: 500 keywords, 5 ad groups, 5 ads",
priceCard2text7:"Display: 1 banner design",
priceCard2text8:"Performance Max campaign",
priceCard2text9:"2 Object Groups",
priceCard2text10:"Campaign optimization",
priceCard2text11:"Free keyword research",
priceCard2text12:"Your campaigns will be managed by experts",
// third card details
priceCard3Subtitle1:"Unlimited",
priceCard3Subtitle2:"Customized Solutions to Your Needs",
priceCard3text1:"Free account audit",
priceCard3text2:"Free Google Ads account setup (if you don't have one)",
priceCard3text3:"Reports",
priceCard3text4:"Setup of 10 (or more) campaigns",
priceCard3text5:"Search: 1000+ keywords, 5+ ad groups, 5+ ads",
priceCard3text6:"Display: 5+ banner designsPerformance Max campaign5+ Object Groups",
priceCard3text7:"Campaign and website optimization",
priceCard3text8:"Setting up conversion tracking for Google Ads",
priceCard3text9:"A/B Testing",
priceCard3text10:"CRM system setup",
priceCard3text11:"Remarketing for search campaigns",
priceCard3text12:"Customer Support on Telegram",



// clients page
clientTitle:"Clients collaborating with Us",
clientSubtitle:"Partnering with us for tailored marketing solutions and exceptional results. Hear from our clients who trust us to drive growth and engagement for their businesses.",
clientCardText0:"Agro Finans Leasing - Leading company in Uzbekistan specializing in electric vehicle leasing.",
clientCardText1:"Chef Pomodoro - A global company specializing in the sale of pizza-making products.",
clientCardText2:"EXANTE - A wealthtech company providing centralized investment solutions and infrastructure for financial institutions.",
clientCardText3:"ALLHDD.COM - A New York-based company specializing in server and networking solutions tailored for enterprise data centers and networks.",
clientCardText4:"AvaTrade - A pioneer in online trading since 2006. The company was established by a team of financial specialists and e-commerce experts to provide optimal trading conditions for individual traders.",
clientCardText5:"Cedrus Residence - A company specializing in luxury apartments in Switzerland, located in the picturesque region of Ticino between the shores of the lake and the green valleys of the Alps.",
clientCardText6:"Saxo Bank - A global investment bank trusted by over 1,000,000 clients worldwide.",
clientCardText7:"UNHCR - The UN Refugee Agency is an international organization dedicated to saving lives.",
clientCardText8:"Trustpilot was founded in 2007 with the goal of creating an independent currency of trust. It is a digital platform that connects businesses and consumers, building trust and inspiring collaboration.",
buttonMore:"View More",
// About Us page
aboutUsTitle:"About Us",
aboutUsSubtitle:"",
aboutUSTextBoxTitle:"About Our Agency",
aboutUSTextBoxText1:"Welcome to our About Us section! We are a dedicated digital marketing agency committed to helping your business thrive in the online landscape. With over 17 years of experience, our team of expert marketers has successfully executed more than 1,000 projects across a variety of niches and countries.",
aboutUSTextBoxText2:"Our mission is to empower your brand, elevate your online presence, and drive tangible results. We take pride in our tailored strategies and innovative approaches to ensure your success. As your trusted partners, we work closely with you to understand your goals and deliver exceptional outcomes.",
aboutUSTextBoxText3:"Join us on this journey and discover the difference our expertise can make in your business growth. Let’s achieve success together!",
aboutUsStatisticText1:"Satisfied Clients",
aboutUsStatisticText2:"Years of Experience",
aboutUsStatisticText3:"International Projects",
// Contact Page
contactTitle:"Let's Get in Touch",
contactSubtitle:"Your ideas and business goals deserve outstanding digital execution. At Adigmo, we're ready to help. Provide your contact details below, and one of our specialists will get in touch soon to discuss your project.",
fullName:"Full Name",
buttonSend:"Send",
// footer section words
footerTitle1:"Company",
footerTitle2:" Marketing",
footerTitle3:"Location",
footerTitle4:"Follow Us",
footerColText1:"Home",
footerColText2:"Our Service",
footerColText3:"Our Price",
footerColText4:"All Projects",
footerCol2Text1:"FAQ",
footerCol2Text2:"Marketing",
footerCol2Text3:"Payment System",
footerCol2Text4:"Status Project ",
footerCol2Text5:"Payment Option",
footerCol3Text1:"Uzbekiston,Tashkent",
footerCol3Text2:"Chilonzor District, Zukhur",
footerCol3Text3:"Polvon, 3-Y House",
footerCol3Text4:"Phone: +998 (97) 753 14 01",
// Succes Page
succesPageTitle:"Hello, my dear friend Adigmo!",
successPageText1:"Well! Your contact form has been successfully submitted! Our team is looking forward to the opportunity to get in touch with you.",
successPageText2:"Expect a call or an email from our specialists soon. Together, we will bring your ideas to life and create a successful partnership.",
successPageText4:"Thank you for contacting Adigmo. We look forward to communicating with you soon!",
successPageText5:"With best regards, Adigmo Team ",
buttonWell:"Good"


}
export default english